import HTTPHandler, { formatResponse } from 'lib/api/HTTPHandler'
import {
  CP_API_URL,
  CS_API_URL,
  INTEGRATION_API_URL,
  MISC_API_URL,
  PPP_API_URL,
  REPORT_API_URL,
  TIRE_API_URL
} from 'lib/api/env'
import { createError } from 'lib/api/serverError'

export class SalesService {
  static sendToFavorites = async id => {
    try {
      const res = await HTTPHandler.post(
        INTEGRATION_API_URL + `/sendToFavorites/${id}`
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static updateSaleStatus = async data => {
    try {
      const res = await HTTPHandler.post(
        CS_API_URL + '/sales/updateSaleStatus',
        data
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getRopStatistics = async params => {
    try {
      const response = await HTTPHandler.get(
        CS_API_URL + '/sales/statisticsForRop?' + this.getSearchParams(params)
      )

      return formatResponse(response)
    } catch (error) {
      return createError(error)
    }
  }

  static getList = async (data = {}, limit = 10, offset = 0) => {
    try {
      const response = await HTTPHandler.post(CS_API_URL + '/sales/list', {
        ...data,
        limit,
        offset
      })

      return formatResponse(response)
    } catch (error) {
      return createError(error)
    }
  }

  static getActiveSales = async () => {
    try {
      const response = await HTTPHandler.get(
        CS_API_URL + '/sales/getMyActiveSale'
      )

      return formatResponse(response)
    } catch (error) {
      return createError(error)
    }
  }

  static getStatusCounts = async () => {
    try {
      const res = await HTTPHandler.get(CS_API_URL + '/sales/getStatusCount')
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getSaleById = async id => {
    try {
      const res = await HTTPHandler.get(CS_API_URL + '/sales/getById/' + id)
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getSalesDiscount = async (data, limit, offset) => {
    try {
      const res = await HTTPHandler.post(CS_API_URL + '/sales/list/discount', {
        ...data,
        limit,
        offset
      })
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getByIdForSelection = async id => {
    try {
      const res = await HTTPHandler.get(
        CS_API_URL + '/sales/getByIdForSelection/' + id
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static createSale = async (data = {}) => {
    try {
      const res = await HTTPHandler.post(CS_API_URL + '/sales/createSale', data)
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static updateSale = async (data = {}) => {
    try {
      const res = await HTTPHandler.patch(CS_API_URL + '/sales', data)
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static updateTireSetStatus = async (data = {}) => {
    try {
      const res = await HTTPHandler.patch(
        TIRE_API_URL + '/tireSet/updateStatus',
        data
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static updateSaleByGlobalId = async (data = {}) => {
    try {
      const res = await HTTPHandler.patch(
        CS_API_URL + '/sales/updateByGlobalId',
        data
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  /*{
    "saleId":1395,
    "status":90,
    "comments":"bla bla"
}

*/
  static updateStatusTrack = async (saleId, status) => {
    try {
      const res = await HTTPHandler.patch(
        CS_API_URL + '/salesStatus/updateStatusTrack',
        { saleId, status }
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static carfinUpdateStatusTrack = async (saleId, status) => {
    try {
      const res = await HTTPHandler.patch(
        CS_API_URL + '/salesStatus/carfinUpdateStatusTrack',
        { saleId, status }
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static updateSelectionOfCars = async (data = {}) => {
    try {
      const res = await HTTPHandler.patch(
        CS_API_URL + '/sales/selectionOfCars',
        data
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static addSaleComments = async (id, data = {}) => {
    try {
      const res = await HTTPHandler.post(
        CS_API_URL + '/sales/comments?saleId=' + id,
        data
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getAllComments = async id => {
    try {
      const res = await HTTPHandler.get(
        CS_API_URL + '/sales/getAllComments/' + id
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static updateSaleCar = async (data = {}) => {
    try {
      const res = await HTTPHandler.patch(CS_API_URL + '/cars', data)
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  /*
  * https://test.asterx.kz/api-ppp/requests/createRequestProcess
    параметры:
    fromSale: true
    urgently: true
  * */
  static createRequestProcess = async (id, data = {}) => {
    try {
      const res = await HTTPHandler.post(
        PPP_API_URL + '/requests/createRequestProcess',
        {
          ...data,
          car: {
            id
          },
          fromSale: true
        }
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getAllSalesByPhone = async phone => {
    try {
      const res = await HTTPHandler.get(
        CS_API_URL + '/sales/getAllSalesByPhone/' + phone
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getWorkOrdersByVin = async vin => {
    try {
      const res = await HTTPHandler.get(
        CS_API_URL + `/cars/getWorkOrdersByVin/${vin}`
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getPastSelection = async id => {
    try {
      const res = await HTTPHandler.get(
        CS_API_URL + '/sales/getPastSelection/' + id
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getSaleByIdForView = async id => {
    try {
      const response = await HTTPHandler.get(
        `${CS_API_URL}/sales/getByIdForView/${id}`
      )

      return formatResponse(response)
    } catch (error) {
      return createError(error)
    }
  }

  static reassignActiveSale = async (phone, seoNumber = '') => {
    try {
      const data = {
        client: {
          phoneNumber: phone.toString().toStandardPhone()
        }
      }
      if (seoNumber && seoNumber.startsWith('M')) {
        data.seoNumber = {
          seoNumber: seoNumber
        }
      }
      const response = await HTTPHandler.post(
        CS_API_URL + '/sales/reassignActiveSale',
        data
      )
      return formatResponse(response)
    } catch (error) {
      return createError(error)
    }
  }

  static getHistoryStatus = async id => {
    try {
      const res = await HTTPHandler.get(
        CS_API_URL + '/salesStatus/historyStatus/' + id
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getAllSaleActivity = async id => {
    try {
      const res = await HTTPHandler.get(
        CS_API_URL + '/sales/getAllSaleActivity/' + id
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getDealsByPhone = async phone => {
    try {
      const res = await HTTPHandler.post(
        CP_API_URL + '/deals/getDealsByPhone',
        {
          phone,
          limit: 10
        }
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getCreditRequestsByPhone = async phone => {
    try {
      const res = await HTTPHandler.post(
        REPORT_API_URL + '/xxx/creditRequestsByPhone',
        {
          phoneNumber: phone?.toStandardPhone()
        }
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getPredodopByPhone = async phone => {
    try {
      const res = await HTTPHandler.get(
        CS_API_URL +
          '/integration/getPreApprovalByPhone/' +
          phone?.toStandardPhone()
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getCertForCar = async certNo => {
    try {
      const res = await HTTPHandler.post(MISC_API_URL + '/discount/list', {
        certNo
      })
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static uploadFiles = async file => {
    try {
      const formData = new FormData()
      formData.append('file', file)
      const res = await HTTPHandler.post(
        CS_API_URL + '/files/uploadFile',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getPriceStatistics = async filter => {
    try {
      const response = await HTTPHandler.get(
        `${REPORT_API_URL}/ads?` +
          this.getSearchParams({
            offset: 0,
            limit: 1000,
            ...filter
          })
      )

      return formatResponse(response)
    } catch (error) {
      return createError(error)
    }
  }

  static sendToPredodop = async id => {
    try {
      const res = await HTTPHandler.post(
        CS_API_URL + '/integration/sendWabaPreApproveMsg/' + id
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static redirectClientSale = token => async (target, saleId) => {
    try {
      const res = await HTTPHandler.post(CS_API_URL + `/sales/redirect`, {
        apiKey: '4zZxcky0lFWTijDt',
        token,
        target,
        saleId
      })
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getStatusesCount = async params => {
    try {
      const res = await HTTPHandler.get(
        CS_API_URL + '/sales/statusesCount?' + this.getSearchParams(params)
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getActiveSeo = async () => {
    try {
      const res = await HTTPHandler.get(CP_API_URL + '/properties/seo')
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getSearchParams = filter => {
    return new URLSearchParams(
      Object.fromEntries(Object.entries(filter).filter(([_, v]) => !!v))
    )
  }

  static getPotrebCreditLink = async branch => {
    try {
      const res = await HTTPHandler.get(
        INTEGRATION_API_URL + `/getPotrebCreditLink?branchCode=${branch}`
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static sendWabaPotrebCredit = async (id, phoneNumber) => {
    try {
      const res = await HTTPHandler.post(
        CS_API_URL +
          `/integration/sendWabaPotrebCredit/${id}?phoneNumber=${phoneNumber}`
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static setAssignTo = async data => {
    try {
      const response = await HTTPHandler.post(
        `${CS_API_URL}/sales/setAssignTo`,
        data
      )

      return formatResponse(response)
    } catch (error) {
      return createError(error)
    }
  }

  static getDiscounts = async () => {
    try {
      const { data } = await HTTPHandler.get(CS_API_URL + '/sales/getDiscounts')
      return data
    } catch (e) {
      console.error(e)
      return []
    }
  }
}
